import API from './apiCreate'
import { getParams } from './getParams'

export type HistoryCategory = 'schedule' | 'journal' | 'ktp' | 'students' | 'employees'
export interface ChangeHistoryRow {
  id: number
  entity_id: number
  entity_type: string
  entity_label: string
  subject_id?: number
  actor_id?: number
  actor_name: string
  action: 'update' | 'delete'
  source: string
  created_at: number
  changes: Record<string, { old: unknown; new: unknown }>
}

export const changeHistoryApi = {
  index: (params: Record<string, unknown>) =>
    API.get(`change-history/index${getParams(params)}`),
  user: (id: number) => API.get(`change-history/user?id=${id}`),
}
